import clsx from 'clsx';

export const PageTitle = ({
  title,
  description,
  className,
  size = 'md',
}: {
  title: string;
  description: string;
  className?: string;
  size?: 'md' | 'lg';
}): JSX.Element => {
  return (
    <div className={className}>
      <h1
        className={clsx(
          'md:text-[3rem] font-bold text-black-light md:leading-[normal] *:bg-gradient-pink-blue *:bg-clip-text *:font-bold *:text-transparent animate-[riseSlow_0.4s_ease-in-out] text-center',
          size === 'lg' ? 'text-[2rem]' : 'text-2xl'
        )}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        className="mt-5 md:mt-8 mx-auto text-center text-sm md:text-xl max-w-[400px] md:max-w-[723px] text-black-light md:leading-[150%] animate-[riseFast_0.8s_ease-in-out] break-words break-keep"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
